module.exports = __webpack_public_path__ + "img/img_target_right_af.077597c1.svg";